/*
  live-price.js (GordijnenXL)
  Doel: maatprijs van de ITORIS Dynamic Product Options (DPO) configurator direct bijwerken tijdens het typen.
  Bevinding (theme/configurator-analyse.md): DPO luistert op keyup/paste/change, niet op 'input'. Mobiele
  toetsenborden en autofill vuren keyup niet altijd, waardoor de prijs pas bij 'change' (verlaten van het veld)
  bijwerkt. Dit script luistert op 'input' en roept dpoOptions.updatePrice(true) aan (debounced).
  De prijs wordt door DPO in .dpo-price-custom geschreven; de thema-scripts kopiëren die naar .dpo-price-custom-1 in de knop.
  Laden: <script src="{{ 'live-price.js' | asset_url }}" defer></script> vlak voor </body> (alleen nodig op producttemplates).
*/
(function () {
  'use strict';
  var DEBOUNCE_MS = 120;
  var timer = null;

  function root() { return document.getElementById('itoris_dynamicproductoptions'); }

  function ready() {
    return !!(window.jQuery && window.dpoOptions && typeof window.dpoOptions.updatePrice === 'function' && root());
  }

  function recalc() {
    if (!ready()) return;
    try {
      // updatePrice() zonder argument cachet en wacht 150 ms; met true schrijft hij direct naar de DOM.
      window.dpoOptions.lastUpdatePriceResult = false;
      window.dpoOptions.updatePrice(true);
    } catch (e) {
      if (window.console && console.debug) console.debug('live-price: updatePrice failed', e);
    }
    syncButton();
  }

  // Vangnet voor de knop "In winkelwagen | prijs" als de thema-observer nog niet actief is.
  function syncButton() {
    var src = document.querySelector('.dpo-price-custom');
    if (!src) return;
    var text = (src.textContent || '').trim();
    if (!text) return;
    var targets = document.querySelectorAll('.dpo-price-custom-1');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].textContent.trim() !== text) targets[i].textContent = text;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(recalc, DEBOUNCE_MS);
  }

  function isTextField(el) {
    if (!el || !el.matches) return false;
    return el.matches('input[type="text"], input[type="number"], input[type="tel"], input:not([type]), textarea');
  }

  function bind() {
    var r = root();
    if (!r || r.__gxlLivePrice) return;
    r.__gxlLivePrice = true;
    r.addEventListener('input', function (e) { if (isTextField(e.target)) schedule(); }, true);
    r.addEventListener('change', function () { schedule(); }, true);
    // Autofill/spraakinvoer: ook bij blur nog een keer.
    r.addEventListener('blur', function (e) { if (isTextField(e.target)) schedule(); }, true);
    recalc();
  }

  function arm() {
    if (window.jQuery && !window.__gxlLivePriceArmed) {
      window.__gxlLivePriceArmed = true;
      window.jQuery(window).on('dpo_initialized', function () { setTimeout(bind, 0); });
    }
  }

  function poll() {
    var n = 0;
    var iv = setInterval(function () {
      arm();
      if (ready()) { bind(); clearInterval(iv); }
      else if (++n > 150) clearInterval(iv); // stop na 30 s (geen DPO op deze pagina)
    }, 200);
  }

  arm();
  if (document.readyState === 'complete') poll(); else window.addEventListener('load', poll);
})();
